//@ts-check

let inited = false;
let callback = null;

/**
 * 
 * @param {PMRule} rule
 * @param {() => Promise} cb 
 */
module.exports = (rule, cb) => {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.Tips_Form', 'inited', (p, widget) => {
			const master_onSubmit = widget.getClass() !== 'Content_Tipme' ? widget.onSubmit : null;
			const master_submit = widget.getClass() === 'Content_Tipme' ? widget.submit : null;

			if (master_onSubmit) {
				widget.onSubmit = (...args) => widget._isValid && callback().then(({ result, params }) => {
					if (result === true) {
						if (params) {
							widget.setOption(
								'preparedTransactionParams',
								{
									...widget.getOption('preparedTransactionParams'),
									...params
								}
							);
						}

						return master_onSubmit.apply(widget, args);
					}
				});
			}

			if (master_submit) {
				widget.submit = (...args) => {
					widget.validateData();

					if (widget._isValid) {
						return callback().then(({ result, params }) => {
							if (result === true) {
								if (params) {
									widget.setOption(
										'preparedTransactionParams',
										{
											...widget.getOption('preparedTransactionParams'),
											...params
										}
									);
								}

								return master_submit.apply(widget, args);
							}
						});
					}

					return master_submit.apply(widget, args);
				};
			}
		}, {
			sync: true,
			prefix: 'user_access_patch_tipsform'
		});
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/common/patch-tips-form.es.js